class DealerOverview {
    constructor() {
        this.root = document.querySelector('.dealer-overview');
        if (!this.root) {
            return;
        }

        this.searchInput = this.root.querySelector('.search-wrapper input');
        this.searchButton = this.root.querySelector('.search-wrapper button');
        this.typeButtons = Array.from(this.root.querySelectorAll('.dealers-site-type button'));
        this.regionContainers = Array.from(this.root.querySelectorAll('.region-container'));
        this.noResults = this.root.querySelector('.dealers-no-results');

        this.activeType = 'all';

        this.setEventListeners();
        this.applyURLParams();
        this.filter();
    }

    applyURLParams() {
        const params = new URLSearchParams(window.location.search);
        const query = params.get('search') || params.get('name') || params.get('city') || params.get('country') || '';

        if (query && this.searchInput) {
            this.searchInput.value = query;
        }

        const type = params.get('type');
        const matchingButton = type && this.typeButtons.find((button) => button.dataset.siteType === type);

        if (matchingButton) {
            this.typeButtons.forEach((btn) => btn.classList.remove('active'));
            matchingButton.classList.add('active');
            this.activeType = type;
        }
    }

    setEventListeners() {
        if (this.searchInput) {
            this.searchInput.addEventListener('input', () => this.filter());
            this.searchInput.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    this.filter();
                }
            });
        }

        if (this.searchButton) {
            this.searchButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.filter();
            });
        }

        this.typeButtons.forEach((button) => {
            button.addEventListener('click', () => {
                this.typeButtons.forEach((btn) => btn.classList.remove('active'));
                button.classList.add('active');
                this.activeType = button.dataset.siteType || 'all';
                this.filter();
            });
        });
    }

    filter() {
        const query = (this.searchInput?.value || '').trim().toLowerCase();
        let visibleCount = 0;

        this.regionContainers.forEach((region) => {
            let regionHasVisibleCountry = false;

            region.querySelectorAll('.country-container').forEach((country) => {
                let countryHasVisibleDealer = false;

                country.querySelectorAll('.dealer').forEach((dealer) => {
                    const matchesSearch =
                        !query ||
                        (dealer.dataset.dealerName || '').toLowerCase().includes(query) ||
                        (dealer.dataset.city || '').toLowerCase().includes(query) ||
                        (dealer.dataset.country || '').toLowerCase().includes(query) ||
                        (dealer.dataset.countrySlug || '').toLowerCase().includes(query);

                    const dealerTypes = (dealer.dataset.siteTypes || '').split(',');
                    const matchesType = this.activeType === 'all' || dealerTypes.includes(this.activeType);

                    const isVisible = matchesSearch && matchesType;
                    dealer.classList.toggle('is-hidden', !isVisible);

                    if (isVisible) {
                        countryHasVisibleDealer = true;
                        visibleCount++;
                    }
                });

                country.classList.toggle('is-hidden', !countryHasVisibleDealer);
                if (countryHasVisibleDealer) {
                    regionHasVisibleCountry = true;
                }
            });

            region.classList.toggle('is-hidden', !regionHasVisibleCountry);
        });

        if (this.noResults) {
            this.noResults.classList.toggle('is-visible', visibleCount === 0);
        }
    }
}

class RegionSelector {
    constructor() {
        this.selector = document.querySelector('.region-selector');
        if (!this.selector) {
            return;
        }

        this.toggleButton = this.selector.querySelector('.region-selector-title');
        this.label = this.toggleButton?.querySelector('span');
        this.anchorLinks = Array.from(this.selector.querySelectorAll('.region-anchor'));
        this.regionContainers = Array.from(document.querySelectorAll('.dealers-content .region-container'));

        this.setEventListeners();

        const initialLink = this.anchorLinks.find((link) => link.classList.contains('active')) || this.anchorLinks[0];
        if (initialLink) {
            this.applyRegion(initialLink);
        }
    }

    setEventListeners() {
        this.toggleButton?.addEventListener('click', (e) => {
            e.preventDefault();
            this.setOpen(!this.selector.classList.contains('active'));
        });

        this.anchorLinks.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                this.applyRegion(link);
                this.setOpen(false);
            });
        });

        document.addEventListener('click', (e) => {
            if (this.selector.classList.contains('active') && !this.selector.contains(e.target)) {
                this.setOpen(false);
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.setOpen(false);
            }
        });
    }

    setOpen(isOpen) {
        this.selector.classList.toggle('active', isOpen);
        this.toggleButton?.setAttribute('aria-expanded', String(isOpen));
    }

    applyRegion(link) {
        this.anchorLinks.forEach((anchor) => anchor.classList.remove('active'));
        link.classList.add('active');

        if (this.label) {
            this.label.textContent = link.textContent;
        }

        const regionSlug = link.dataset.region;
        const isAll = regionSlug === 'region-all';

        this.regionContainers.forEach((container) => {
            container.classList.toggle('active', isAll || container.dataset.region === regionSlug);
        });
    }
}

new DealerOverview();
new RegionSelector();
